const getSlugbrand = (brand) => {

	if (brand?.type) {

		return `${brand.type}/${brand.slug}`;

	}
	return `product/${brand?.slug}`;

};

export default getSlugbrand;
